/**
 * supplierSelectionHelpers.ts
 * 협력사 선택 페이지 관련 상수 및 헬퍼 함수
 */
import { SupplierDetail } from '../types/supplier.types';

// ========================================
// 상수 정의
// ========================================

/**
 * 필터 저장 키
 */
export const FILTER_STORAGE_KEY = 'supplierSelectionFilters';

/**
 * 운영 상태 옵션
 */
export const OPERATION_STATUS_OPTIONS = [
    { value: '전체', label: '전체' },
    { value: '운영중', label: '운영중' },
    { value: '운영중지', label: '운영중지' },
    { value: '계약종료', label: '계약종료' },
    { value: '계약종료 접수', label: '계약종료 접수' }
] as const;

/**
 * 허용된 엑셀 파일 확장자
 */
export const ALLOWED_EXCEL_EXTENSIONS = ['.xlsx', '.xls'] as const;

// ========================================
// 타입 정의
// ========================================

export interface SupplierFilters {
    supplierName: string;
    supplierId: string;
    operationStatus: string;
}

// ========================================
// 헬퍼 함수
// ========================================

/**
 * 초기 필터 상태 반환
 */
export const getDefaultFilters = (): SupplierFilters => ({
    supplierName: '',
    supplierId: '',
    operationStatus: '전체'
});

/**
 * 협력사 목록 필터링
 * @param suppliers 전체 협력사 목록
 * @param filters 필터 조건
 */
export const filterSuppliers = (
    suppliers: SupplierDetail[],
    filters: SupplierFilters
): SupplierDetail[] => {
    let filtered = [...suppliers];

    if (filters.supplierName) {
        filtered = filtered.filter(s =>
            s.name.toLowerCase().includes(filters.supplierName.toLowerCase())
        );
    }

    if (filters.supplierId) {
        filtered = filtered.filter(s =>
            s.id.toLowerCase().includes(filters.supplierId.toLowerCase())
        );
    }

    if (filters.operationStatus && filters.operationStatus !== '전체') {
        filtered = filtered.filter(s =>
            s.operationStatus === filters.operationStatus
        );
    }

    return filtered;
};

/**
 * 엑셀 파일 확장자 유효성 검사
 * @param fileName 파일명
 */
export const isValidExcelFile = (fileName: string): boolean => {
    return ALLOWED_EXCEL_EXTENSIONS.some(ext => fileName.endsWith(ext));
};
